import { render, staticRenderFns } from "./IntegralConfigAdd.vue?vue&type=template&id=28111340&scoped=true"
import script from "./IntegralConfigAdd.vue?vue&type=script&lang=js"
export * from "./IntegralConfigAdd.vue?vue&type=script&lang=js"
import style0 from "./IntegralConfigAdd.vue?vue&type=style&index=0&id=28111340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28111340",
  null
  
)

export default component.exports